import { StyleSheet } from 'react-native';
import { Divider } from '../../../components/primitives/Divider';
import { Select } from '../../../components/primitives/Select';
import { HStack, VStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { Toggle } from '../../../components/primitives/Toggle';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';
import { useLanguageSync } from '../hooks/useLanguageSync';
import { SettingsSection } from './SettingsSection';

const LANGUAGE_KEYS = [
  { value: 'en', labelKey: 'settings.appearance.languages.english' },
  { value: 'es', labelKey: 'settings.appearance.languages.spanish' },
  { value: 'pt', labelKey: 'settings.appearance.languages.portuguese' },
];

export function AppearanceSection() {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguageSync();

  return (
    <SettingsSection title={t('settings.appearance.title')}>
      <VStack spacing="sm" style={{ position: 'relative', zIndex: tokens.zIndex.dropdown }}>
        <Text variant="bodySmall" color={colors.text.primary} style={styles.label}>
          {t('settings.appearance.language')}
        </Text>
        <Select
          variant="dropdown"
          options={LANGUAGE_KEYS.map((k) => ({ value: k.value, label: t(k.labelKey) }))}
          value={language}
          onChange={(val) => changeLanguage(val as 'en' | 'es' | 'pt')}
        />
      </VStack>

      <Divider />

      <HStack spacing="md" align="center" justify="between">
        <VStack spacing="xxs" style={styles.themeInfo}>
          <Text variant="bodySmall" color={colors.text.primary} style={styles.label}>
            {t('settings.appearance.dark')}
          </Text>
          <Text variant="caption" color={colors.text.tertiary}>
            {t('settings.appearance.lightComingSoon')}
          </Text>
        </VStack>
        <Toggle
          value
          onValueChange={() => undefined}
          disabled
          accessibilityLabel={t('settings.appearance.dark')}
          accessibilityHint={t('settings.appearance.lightComingSoon')}
        />
      </HStack>
    </SettingsSection>
  );
}

const styles = StyleSheet.create({
  label: {
    fontWeight: '500',
  },
  themeInfo: {
    flex: 1,
    minWidth: 0,
  },
});
